import { render, staticRenderFns } from "./Shareholder.vue?vue&type=template&id=667ea334&scoped=true&"
import script from "./Shareholder.vue?vue&type=script&lang=js&"
export * from "./Shareholder.vue?vue&type=script&lang=js&"
import style0 from "./Shareholder.vue?vue&type=style&index=0&id=667ea334&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "667ea334",
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("C:\\wamp64\\www\\corpmessengerwebapp_rtp\\node_modules\\vue-hot-reload-api\\dist\\index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('667ea334')) {
      api.createRecord('667ea334', component.options)
    } else {
      api.reload('667ea334', component.options)
    }
    module.hot.accept("./Shareholder.vue?vue&type=template&id=667ea334&scoped=true&", function () {
      api.rerender('667ea334', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/pages/LMSGiframe/components/Shareholder.vue"
export default component.exports